import { vaccinationOutcomeReasonApi } from "api/immunization";
import { humanise } from "config/immunizationConstants";
import MasterListScreen from "./common/MasterListScreen";
import VaccinationOutcomeReasonModal from "./VaccinationOutcomeReasonModal";

const VaccinationOutcomeReasonList = ({ searchText = "" }) => (
  <MasterListScreen
    resource={vaccinationOutcomeReasonApi}
    label="Vaccination outcome reason"
    entityLabel="outcome reason"
    addLabel="Add Outcome Reason"
    tag="immunization-outcome-reason"
    headers={[
      "Name",
      "Code",
      "Applies To",
      "Counts As Decline",
      "Requires",
      "Status",
      "Action",
    ]}
    keys={[
      "name",
      "code",
      "statusLabel",
      "declineLabel",
      "requiresLabel",
      "statusChip",
      "action",
    ]}
    displayName={(item) => item.display}
    mapRow={(item) => ({
      statusLabel: humanise(item.appliesToStatus),
      declineLabel: item.countsAsDecline ? "Yes" : "No",
      requiresLabel:
        [
          item.requiresNote ? "Note" : null,
          item.requiresFollowUpDate ? "Follow-up date" : null,
        ]
          .filter(Boolean)
          .join(", ") || "—",
    })}
    Modal={VaccinationOutcomeReasonModal}
    searchText={searchText}
  />
);

export default VaccinationOutcomeReasonList;
